import { memo } from 'react'
import { t } from 'i18next'
import { IconButton, useTheme } from '@mui/material'
import { useAppContext } from 'context/AppContext'

import { IconMoon01, IconSun } from 'assets/icons'

const SidebarTheme = memo((): JSX.Element => {
  const theme = useTheme()
  const { changeTheme } = useAppContext()

  const content = {
    light: {
      icon: IconSun,
      text: t('sidebar.theme.lightButtonText'),
    },
    dark: {
      icon: IconMoon01,
      text: t('sidebar.theme.darkButtonText'),
    },
  }

  return (
    <IconButton
      sx={{ svg: { width: '20px', height: '20px' } }}
      onClick={changeTheme}
      aria-label={content[theme.palette.mode].text}
    >
      {content[theme.palette.mode].icon}
    </IconButton>
  )
})

SidebarTheme.displayName = 'SidebarTheme'

export { SidebarTheme }
